import script from "./NoticiasCentralCoordenacao.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiasCentralCoordenacao.vue?vue&type=script&setup=true&lang=js"

import "./NoticiasCentralCoordenacao.vue?vue&type=style&index=0&id=1f9da1eb&scoped=true&lang=css"
import "./NoticiasCentralCoordenacao.vue?vue&type=style&index=1&id=1f9da1eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9da1eb"]])

export default __exports__